import instance from "@connection/instance";
import { useState } from "react";
import { notifications } from '@mantine/notifications';

const useControl = (t) => {
  const [control, setControl] = useState()
  const [fetched, setFetched] = useState(false)

  const fetch = async (id) => {
    const { data: { response, errors: fetchErrors }} = await instance.get(`/api/place/${id}/control`);

    if (fetchErrors?.length > 0) {
      return { errors: fetchErrors }
    }

    setControl(response);
    setFetched(true);
  }

  const unbound = async (id, data) => {
    const { data: { response, errors: fetchErrors }} = await instance.put(`/api/place/${id}/control`, data);

    if (fetchErrors?.length > 0) {
      notifications.show({
        title: t('notifications.managment.unbound.error'),
        autoClose: 2000
      });

      return { errors: fetchErrors }
    }

    notifications.show({
      title: t('notifications.managment.unbound.success'),
      autoClose: 2000
    });

    setControl(null);
  }

  return [
    {
      control,
      fetched
    },
    {
      fetch,
      unbound
    }
  ]
}

export default useControl;
